// src/redux/thunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { withRFSToken } from '../../Services/axios';
import { ULDEXISTS } from '../../Utils/conts';

export const fetchULDEDetails = createAsyncThunk(
  'Airline/fetchDetails',
  async ({ id, nmbr }, { rejectWithValue }) => {
    try {
      const response = await withRFSToken.post(ULDEXISTS, { uld_number: nmbr });
      return { id, data: response.data.response_data };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
